import { cn } from '@repo/utils/cn';
import { ComponentType, SVGProps } from 'react';

type IconType = ComponentType<SVGProps<SVGSVGElement>>;

const tenantColorMap: Record<string, string> = {
  'vatan-game': 'vt-colors-accents-accent-2-600',
  'hazarat-game': 'vt-colors-accents-accent-2-600',
  betnana: 'vt-colors-accents-accent-3-600',
};

export const renderIcon = (DefaultIcon: IconType, Icon?: IconType, tenantName?: string) => {
  const iconClassName = 'size-5 flex-shrink-0';
  const colorClass = tenantName ? tenantColorMap[tenantName] : '';

  const FinalIcon = Icon && colorClass ? Icon : DefaultIcon;

  return <FinalIcon className={cn(colorClass, iconClassName)} />;
};
